import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = (state) => state.degree || initialState;

const makeSelectDegreeFilterMenuStatus = () =>
  createSelector(selectGlobal, (degreeState) => degreeState.degreeFilterMenuStatus);

export { makeSelectDegreeFilterMenuStatus };
